import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

interface HeroSectionProps {
  onStartDiagnostic?: () => void;
}

export function HeroSection({ onStartDiagnostic }: HeroSectionProps) {
  return (
    <section
      className="min-h-screen flex flex-col items-center justify-center px-4 sm:px-8 lg:px-16 py-20 relative overflow-hidden"
      aria-labelledby="hero-heading"
    >
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-transparent to-transparent pointer-events-none" />
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-5xl text-center space-y-8 relative z-10">
        {/* Tag */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-border bg-secondary/50 text-sm text-muted-foreground uppercase tracking-wider opacity-0 animate-fade-in">
          <Sparkles className="w-4 h-4 text-primary" />
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
          Powered by AI
        </div>

        {/* Main heading */}
        <h1
          id="hero-heading"
          className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl leading-tight opacity-0 animate-fade-in"
          style={{ animationDelay: '100ms' }}
        >
          Descubra o que está <span className="text-primary">travando</span> sua operação de Produto
          e Tech
        </h1>

        {/* Subtitle */}
        <p
          className="text-lg sm:text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto leading-relaxed opacity-0 animate-fade-in"
          style={{ animationDelay: '200ms' }}
        >
          Diagnóstico guiado por IA que avalia decisões, fluxo e execução da sua operação em poucos
          minutos.
        </p>

        {/* CTA */}
        <div
          className="pt-6 flex flex-col sm:flex-row items-center justify-center gap-4 opacity-0 animate-fade-in"
          style={{ animationDelay: '300ms' }}
        >
          <Button
            size="lg"
            className="text-lg px-8 py-7 min-w-[240px] rounded-full group"
            onClick={onStartDiagnostic}
          >
            Iniciar diagnóstico
            <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" />
          </Button>
          <span className="text-sm text-muted-foreground">
            Gratuito • Sem necessidade de cadastro
          </span>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-muted-foreground">
        <span className="text-xs uppercase tracking-widest">Scroll</span>
        <div className="w-px h-8 bg-gradient-to-b from-muted-foreground to-transparent" />
      </div>
    </section>
  );
}
